import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import {
  PhasrBehavioralProfilesComponentBaseDataProvider,
} from '../dataProvider/PhasrBehavioralProfilesComponentBaseDataProvider';

export class PhasrBehavioralProfilesComponentDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrBehavioralProfilesComponentBaseDataProvider);
  }
}
